var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindTurbine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.58px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 89.71,
    y1: 192.69,
    x2: 125.84,
    y2: 192.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.87,
    y1: 126.04,
    x2: 140.29,
    y2: 121.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.66,141.3s7.22-1.61,20.07-13.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158,86.7s10.44-34.53-24.09-47.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.56,43.34s20.88,16.06,10.44,49"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.98,
    cy: 84.29,
    r: 8.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "105.77 94.73 98.54 192.69 117.01 192.69 111.39 93.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "108.17 72.24 104.16 64.21 110.58 18.45 124.23 20.85 118.61 65.02 108.98 75.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "121.12 90.3 129.94 88.6 172.28 107.12 166.28 119.62 125.27 102.3 117.81 90.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "98.3 91.02 92.5 97.88 47.92 110.06 44.74 96.56 87.53 84.29 100.93 89.02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindTurbine);
export default __webpack_public_path__ + "static/media/WIND_TURBINE.41450d801009000835e1865effaec667.svg";
export { ForwardRef as ReactComponent };